// React & Routing
import { FunctionComponent } from "react";
import { useParams } from "react-router-dom";

// Component(s)
import PortalVideoLinkPlayerSamsaraIncident from "./PortalVideoLinkPlayerSamsaraIncident/PortalVideoLinkPlayerSamsaraIncident";

interface RouteParams {
  videoType: string;
  objectId: string;
}

/**
 * PortalVideoLinkPlayer
 * ---------------------
 * Wrapper component that selects and renders the appropriate
 * video player based on the `videoType` route parameter.
 *
 * Supported route:
 *   /portal-video-player/:videoType/:objectId
 *
 * Currently supported videoType values:
 *   - "samsara-incident" → renders <PortalVideoLinkPlayerSamsaraIncident />
 *
 * Invalid or unsupported values will display a fallback error.
 */
const PortalVideoLinkPlayer: FunctionComponent<{}> = () => {
  const { videoType, objectId } = useParams<RouteParams>();

  // Parse objectId safely
  const objectIdInt = parseInt(objectId, 10);

  // If videoType is supported and objectId is valid, render correct player
  if (videoType === "samsara-incident" && !isNaN(objectIdInt)) {
    return (
      <div className="PortalVideoLinkPlayer main-content col-sm">
        <PortalVideoLinkPlayerSamsaraIncident objectId={objectIdInt} />
      </div>
    );
  }

  // Invalid route fallback
  return (
    <div className="PortalVideoLinkPlayer main-content col-sm">
      <div className="PortalVideoLinkPlayerError">
        <h2>Malformed Video URL</h2>
        <p>
          Please check the link or contact <strong>Help Desk</strong> if this keeps happening.
        </p>
        <a href="tel:+14063272011">(406) 327-2011</a>
        <br />
        <br />
        <a href="mailto:elmhelpdesk@elmutility.com">elmhelpdesk@elmutility.com</a>
      </div>
    </div>
  );
};

export default PortalVideoLinkPlayer;
